import ResetForm from './ResetForm'

export default ResetForm



// WEBPACK FOOTER //
// ./src/views/Reset/components/ResetForm/index.js